import PD from "./PersonalDashboard";
import Wd from "./Widget";
export var PersonalDashboard = PD;
export var Widget = Wd;